import React from 'react'

const OrderHistory = ({ width, height }) => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 13">
        <path
          d="M9.5 3.886a5.588 5.588 0 0 0-3.446 1.182h.935a.443.443 0 1 1 0 .886H4.92a.443.443 0 0 1-.443-.443V3.443a.443.443 0 0 1 .886 0v1.043A6.5 6.5 0 1 1 3 9.5a4.631 4.631 0 0 1 .068-.8.443.443 0 1 1 .877.129 3.835 3.835 0 0 0-.06.673A5.614 5.614 0 1 0 9.5 3.886zm.3 1.92a.443.443 0 0 0-.886 0v3.842a.443.443 0 0 0 .443.443h1.773a.443.443 0 0 0 0-.886H9.8z"
          transform="translate(-3 -3)"
          style={{ fill: '#b1b1b1' }}
        />
      </svg>
    </div>
  )
}

export default OrderHistory
